import { render, staticRenderFns } from "./notification-data-upload.view.vue?vue&type=template&id=38f56780&"
import script from "./notification-data-upload.view.vue?vue&type=script&lang=ts&"
export * from "./notification-data-upload.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports